export default {
  vision: "vision".toUpperCase(),
  thats_the_vision: "мы — Vision".toUpperCase(),
  all_rights__: "2025 VISION. Все права защищены.",
};
